import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { getEstiloTipo, getSiglaTipo } from "../utils/coresTipoProcedimento";

export default function ChipTipoProcedimento({ tipo, mostrarSigla = true }) {
  if (!tipo) {
    return <span style={{ color: "#ccc" }}>—</span>;
  }

  const estilo = getEstiloTipo(tipo);
  const label = mostrarSigla ? getSiglaTipo(tipo) : tipo;

  return (
    <Tooltip title={tipo} arrow>
      <Chip
        label={label}
        size="small"
        sx={{
          backgroundColor: estilo.backgroundColor,
          color: estilo.color,
          fontWeight: 700,
          fontSize: "10px",
          borderRadius: "6px",
          minWidth: mostrarSigla ? "36px" : "auto",
        }}
      />
    </Tooltip>
  );
}
